import { createContext, useContext, useState, useEffect, type ReactNode } from 'react'

const STORAGE_KEY = 'selectedBusinessId'

interface BusinessContextValue {
  selectedBusinessId: string | null
  setSelectedBusinessId: (id: string | null) => void
}

const BusinessContext = createContext<BusinessContextValue | null>(null)

export function BusinessProvider({ children }: { children: ReactNode }) {
  const [selectedBusinessId, setSelectedBusinessIdState] = useState<string | null>(() => {
    // Initialize from localStorage
    if (typeof window !== 'undefined') {
      return localStorage.getItem(STORAGE_KEY)
    }
    return null
  })

  // Persist to localStorage when selection changes
  useEffect(() => {
    if (selectedBusinessId) {
      localStorage.setItem(STORAGE_KEY, selectedBusinessId)
    } else {
      localStorage.removeItem(STORAGE_KEY)
    }
  }, [selectedBusinessId])

  const setSelectedBusinessId = (id: string | null) => {
    setSelectedBusinessIdState(id)
  }

  return (
    <BusinessContext.Provider value={{ selectedBusinessId, setSelectedBusinessId }}>
      {children}
    </BusinessContext.Provider>
  )
}

export function useBusinessContext() {
  const context = useContext(BusinessContext)
  if (!context) {
    throw new Error('useBusinessContext must be used within a BusinessProvider')
  }
  return context
}
